import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";

const PaymentCancel: React.FC = () => {
  const navigate = useNavigate();

  const handleGoToLogin = () => {
    navigate("/auth/login");
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-neutral-50">
      <div className="w-full max-w-md p-8 bg-white border rounded-lg shadow-sm border-neutral-200">
        <div className="space-y-6 text-center">
          <div className="flex items-center justify-center w-16 h-16 mx-auto rounded-full bg-neutral-100">
            <svg
              className="w-10 h-10 text-neutral-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <div>
            <h2 className="text-2xl font-semibold tracking-tight text-black">
              Payment Cancelled
            </h2>
            <p className="mt-2 text-sm text-neutral-600">
              Your payment was cancelled. No charges have been made to your account.
            </p>
          </div>
          <div className="p-4 border rounded-md bg-neutral-50 border-neutral-200">
            <p className="text-sm text-neutral-600">
              If you experienced any issues during checkout, please try again or
              contact our support team for assistance.
            </p>
          </div>
          <Button
            onClick={handleGoToLogin}
            className="w-full"
          >
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
